const getRetellCallDetails = async ({callId}) => {
  const endpoint = `https://api.retellai.com/v2/get-call/${callId}`;
  const apiKey = process.env.REACT_APP_RETELL_API_KEY;

try {
    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiKey}`,
      },
    });

    const api_response = await response.json();
    console.log("GET response:", api_response);
    return api_response;
  } catch (err) {
    console.error("GET error:", err);
  }
};

export default getRetellCallDetails;
